/** @format */

function LinebusterAPI() {
  this.objectToFormData = function (obj) {
    var formData = new FormData();
    Object.keys(obj).forEach(function (key) {
      formData.append(key, obj[key]);
    });

    return formData;
  };

  this.objectToJsonData = function (obj) {
    return JSON.stringify(obj);
  };

  this.apiHeaders = function (wssid) {
    return new Headers({
      "X-WSSID-Authorization": wssid,
    });
  };

  this.createFormPostRequest = function (url, wssid, data) {
    var options = {
      method: "post",
      headers: this.apiHeaders(wssid),
    };

    if (data) {
      options.body = this.objectToFormData(data);
    }

    return new Request(url, options);
  };

  this.createJsonPostRequest = function (url, wssid, data) {
    var headers = this.apiHeaders(wssid);
    headers.set("Content-Type", "application/json; charset=UTF-8");
    headers.set("Accept", "application/json");

    var options = {
      method: "post",
      headers: this.apiHeaders(wssid),
    };

    if (data) {
      options.body = this.objectToJsonData(data);
    }

    return new Request(url, options);
  };

  this.createGetRequest = function (url, wssid, params) {
    var location = new URL(url);

    var options = {
      method: "get",
      headers: this.apiHeaders(wssid),
    };

    if (params) {
      var searchParams = new URLSearchParams(params);
      location.search = searchParams.toString();
    }

    return new Request(location, options);
  };

  /**
   *
   * @param {Request} request
   * @param {*} data
   */
  this.createJsonGetRequest = function (url, wssid, params) {
    var headers = this.apiHeaders(wssid);
    headers.set("Content-Type", "application/json; charset=UTF-8");
    headers.set("Accept", "application/json");

    var base = window.document.location.protocol + "//" + window.document.location.host
    var location = new URL(url, base);

    var options = {
      method: "get",
      headers: headers,
    };

    if (params) {
      var searchParams = new URLSearchParams(params);
      location.search = searchParams.toString();
    }

    return new Request(url, options);
  };

  this.apis = {
    employee: {
      environmentProperties: function (wssid) {
        var defaultProperties = {
          "cia.googleIntegration.enabled": false,
        };

        return fetch(this.createJsonGetRequest("/qless/api/v1/employee/properties", wssid)).then(
          function (response) {
            if (response.ok && response.status < 300) {
              return response.json();
            } else {
              return defaultProperties;
            }
          },
          function () {
            // Request failed due to Network or Permissions issues
            return defaultProperties;
          }
        );
      }.bind(this),
    },
  };
}
